import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { initializeState, reportCleared } from "../../../store/sdlcReportSlice";
import { initFilter, initSort } from "../behavior/utils";
import { resetAllSlices, restoreState } from "./utils";
export const initialState = {
    filter: initFilter,
    sort: initSort,
    pagination: { itemsPerPage: 10, currentPage: 1 },
    filteredByLink: false,
};
const behaviorSlice = createSlice({
    name: "fileBrowserBehavior",
    initialState: initialState,
    reducers: {
        filterUpdated: (state, action) => {
            state.filter = action.payload;
            state.filteredByLink = false;
            state.pagination.currentPage = 1;
        },
        filterByBehaviorId: (state, action) => {
            state.filter.idAndDescription = action.payload;
            state.filteredByLink = true;
            state.pagination.currentPage = 1;
        },
        filterByMlDetected: (state, action) => {
            state.filter = cloneDeep(initFilter);
            state.filter.showMlDetected = action.payload;
            state.filteredByLink = true;
            state.pagination.currentPage = 1;
        },
        sortUpdated: (state, action) => {
            state.sort = action.payload;
            state.pagination.currentPage = 1;
        },
        paginationUpdated: (state, action) => {
            state.pagination = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(initializeState, (state, action) => {
            return restoreState(state, action.payload, "behavior");
        });
        builder.addCase(reportCleared, () => {
            return cloneDeep(initialState);
        });
        builder.addCase(resetAllSlices, () => {
            return cloneDeep(initialState);
        });
    },
});
export const behaviorReducer = behaviorSlice.reducer;
export const { filterUpdated, filterByBehaviorId, filterByMlDetected, paginationUpdated, sortUpdated, } = behaviorSlice.actions;
export const selectFilter = (state) => state.report.fileBrowser.behavior.filter;
export const selectSort = (state) => state.report.fileBrowser.behavior.sort;
export const selectPagination = (state) => state.report.fileBrowser.behavior.pagination;
export const selectFilteredByLink = (state) => state.report.fileBrowser.behavior.filteredByLink;
//# sourceMappingURL=behaviorSlice.js.map